export default "__VITE_ASSET__CSzZfYMQ__"